
<template>
    <v-stepper alt-labels class="stepper-politica" v-model="numeroStep" :style="cssProps">
        <v-row justify="center"
               class="header-steps">
            <v-col class="d-flex steps-container">
                <template v-for="(step, i) in stepsPoliticaComputed">
                    <v-stepper-step :key="i" class="flex justify-center" :complete="numeroStep > i+1" :step="i+1" :class="{'v-stepper__step--active': i+1 === numeroStep, 'step-hoverable' : isStepPrevious(i)}">
                        <template v-if="isStepPrevious(i)">
                            <v-tooltip top
                                       max-width="250px"
                                       color="warning"
                                       nudge-right="180"
                            >
                                <template #activator="{ on, attrs }">
                                    <div v-on="on" v-bind="attrs" style="display: flex; align-items: center;" @click="abrirModalConfirmacao(i)">
                                        <p class="step-label titulo">
                                            <v-icon>{{ step.icon }}</v-icon>
                                            {{ step.text }}
                                        </p>
                                    </div>
                                </template>
                                <div class="d-flex align-center">
                                    <v-icon color="black" class="font-weight-bold mr-2">mdi-information</v-icon>
                                    <span style="color: black" class="font-weight-bold text-center">Clique aqui para voltar até essa etapa!</span>
                                </div>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            <div style="display: flex; align-items: center;">
                                <p class="step-label titulo">
                                    <v-icon>{{ step.icon }}</v-icon>
                                    {{ step.text }}
                                </p>
                            </div>
                        </template>
                    </v-stepper-step>
                </template>
            </v-col>
        </v-row>
        <DialogVoltarEtapas
                v-model="showModal"
                @confirm="voltarEtapa()"
        />
        <PreparacaoAmbienteBroker v-if="numeroStep === 1" :show="showModalBroker" @finished="showModalBroker = false" @goToSales="$router.push('/minhas-vendas')" />
    </v-stepper>
</template>

<script>

  import { GetStepsPolitica } from '../../plugins/helpers'
  import { colorRes } from '@/plugins/flavors'
  import Color from 'color'
  import { mapState } from 'vuex'
  import DialogVoltarEtapas from '../DialogVoltarEtapas.vue'
  import PreparacaoAmbienteBroker from '../broker/PreparacaoAmbienteBroker.vue'
  import preparacaoAmbienteBrokerMixin from '@/mixins/broker/preparacaoAmbienteBrokerMixin'
  export default {
    name: 'StepperPoliticaVendas',
    components: { DialogVoltarEtapas, PreparacaoAmbienteBroker },
    mixins: [preparacaoAmbienteBrokerMixin],
    props: {
      pagina: { type: Number, required: true }
    },
    data: () => ({
      numeroStep: 1,
      showModal: false,
      selectedStep: null,
      assinatura_obrigatoria_grupos_pontuais: false,
      assinatura_obrigatoria_grupos_convencionais: false,
      exibe_asssinatura_obrigatoria_tela_pagamento: true,
      stepsPolitica: []
    }),
    computed: {
      ...mapState([
        'permite_multiplicar_cota'
      ]),
      exibirAssinaturaContrato () {
        return this.assinatura_obrigatoria_grupos_pontuais || this.assinatura_obrigatoria_grupos_convencionais
      },
      exibirContratoAlocacao () {
        return !this.exibe_asssinatura_obrigatoria_tela_pagamento
      },
      cssProps () {
        return {
          '--secondaryTransparent': Color(colorRes().secondary).alpha(0.15),
          '--primaryTransparent': Color(colorRes().primary).alpha(0.15)
        }
      },
      stepsPoliticaComputed () {
        return this.stepsPolitica
      }
    },
    created () {
      this.numeroStep = this.pagina
    },
    async mounted () {
      try {
        if (this.$route && this.$route.params && this.$route.params.skip_preparacao) {
          this.showModalBroker = false
          const params = { ...this.$route.params }
          delete params.skip_preparacao
          this.$router.replace({ name: this.$route.name, params }).catch(() => {})
        }
      } catch (e) {
      }

      await this.loadConfiguracao()
      this.stepsPolitica = GetStepsPolitica(this.exibirAssinaturaContrato, this.exibirContratoAlocacao, this.permite_multiplicar_cota)
    },
    methods: {
      async loadConfiguracao () {
        await this.$http.get('/configuracao/get')
          .then(result => {
            if (result.data) {
              this.assinatura_obrigatoria_grupos_pontuais = result.data.assinatura_obrigatoria_grupos_pontuais
              this.assinatura_obrigatoria_grupos_convencionais = result.data.assinatura_obrigatoria_grupos_convencionais
              this.exibe_asssinatura_obrigatoria_tela_pagamento = result.data.exibe_asssinatura_obrigatoria_tela_pagamento
              this.$store.state.permite_multiplicar_cota = result.data.permite_multiplicar_cota
            }
          })
          .catch(err => console.error(err, 'Não foi possível buscar a configuração!'))
      },
      isStepPrevious (stepIndex) {
        return (stepIndex + 1) < this.numeroStep
      },
      abrirModalConfirmacao (step) {
        this.selectedStep = step
        this.showModal = true
      },
      voltarEtapa () {
        if (this.selectedStep !== null) {
          this.numeroStep = this.selectedStep + 1
          this.$emit('voltarEtapa', this.numeroStep)
          this.selectedStep = null
        }
      }

    }
  }

</script>

<style lang="scss" scoped>
    .header-steps {
        border-bottom: 1px solid var(--lightgray)
    }

    .step-hoverable {
        position: relative;
        overflow: hidden;
        z-index: 0;
        transition: color 0.2s;
    }

    .step-hoverable::before {
        content: "";
        position: absolute;
        top: 0; left: 0; bottom: 0;
        width: 0;
        background: var(--secondaryTransparent);
        z-index: -1;
        transition: width 0.3s;
    }

    .step-hoverable:hover::before {
        width: 100%;
    }

    .step-hoverable .step-label {
        cursor: pointer;
    }

    .step-hoverable:hover .step-label,
    .step-hoverable:hover .v-icon {
        color: var(--secondary) !important;
    }

    .steps-container {
        max-width: 1200px;
        border-bottom: 1px solid var(--lightgray);
        white-space: nowrap;
    }

    .steps-container .v-icon {
        vertical-align: middle;
        font-size: 18px;
        margin-right: 5px;
        margin-top: -2px;
    }

    .steps-container .step-label {
        display: block !important;
        text-transform: uppercase;
        font-size: 14px;
        margin-bottom: 0;
    }

    .steps-container .step-label, .steps-container .v-icon {
        color: var(--gray);
    }

    .steps-container .v-stepper__step--active {
        background: var(--secondaryTransparent);
    }

    .steps-container .v-stepper__step--active .step-label,
    .steps-container .v-stepper__step--active .v-icon {
        color: var(--secondary);
    }

    .steps-container .v-stepper__step--complete .step-label,
    .steps-container .v-stepper__step--complete .v-icon {
        color: var(--primary);
    }

    .step-content {
        padding: 15px;
    }

    .stepper-politica{
      background: none;
      box-shadow: none;
      -webkit-box-shadow: none;
    }
</style>

<!--suppress CssUnusedSymbol -->
<style>
    .v-stepper__step__step {
        display: none !important;
    }

    .v-stepper__label {
        display: block !important;
    }
</style>
